import { ErrorBoundary } from "@components/ui";
import { installGlobalErrorLogging } from "@services/clientLog";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { Toaster } from "react-hot-toast";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles/globals.css";

installGlobalErrorLogging();

// Clean up any stale localStorage data on app startup
// This ensures old cached data from previous versions doesn't cause issues
const AUTH_STORAGE_KEY = "beyond-class-auth";
const CURRENT_VERSION = 4;

try {
  const storedData = localStorage.getItem(AUTH_STORAGE_KEY);
  if (storedData) {
    const parsed = JSON.parse(storedData);
    if (!parsed.version || parsed.version < CURRENT_VERSION) {
      console.log("[Startup] Clearing stale auth data from localStorage");
      localStorage.removeItem(AUTH_STORAGE_KEY);
    }
  }
} catch {
  // If parsing fails, clear the storage
  console.log("[Startup] Clearing corrupted auth data from localStorage");
  localStorage.removeItem(AUTH_STORAGE_KEY);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: "#363636",
                color: "#fff",
              },
              success: {
                iconTheme: {
                  primary: "#22c55e",
                  secondary: "#fff",
                },
              },
              error: {
                iconTheme: {
                  primary: "#ef4444",
                  secondary: "#fff",
                },
              },
            }}
          />
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
